// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"loading_loadingContainer__1riyq","loading":"loading_loading__1GRCx","noBackground":"loading_noBackground__2LZe3","fullscreen":"loading_fullscreen__3Uxe3"};